/**
 * FikoUretimMenu Dialog — "Üretim & Maliyet" modül menüsü
 * 11+ katma-değer modülünü tek açılır listede toplar (toolbar declutter).
 * Tıklayınca ilgili parent açıcı metodu çağırır + menüyü kapatır.
 */
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

interface MenuOge { ad: string; simge: string; metod: string; vurgu?: boolean; grup?: string; alt?: string; }

@Component({
  selector: 'fikoyt-uretim-menu',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
  template: `
  <div class="um">
    @for (o of ogeler; track o.metod) {
      <button class="um-oge" [class.vurgu]="o.vurgu" [class.fiko-kilit]="kilitli(o)" (click)="ac(o)">
        <span class="um-s">{{ o.simge }}</span>
        <span class="um-ad">{{ o.ad }}</span>
        <span class="um-ok">›</span>
      </button>
    }
  </div>
  `,
  styles: [`
    .um { padding:6px; min-width:260px; max-width:300px;
      background:linear-gradient(180deg,rgba(0,40,60,.96),rgba(0,18,36,.98)); border-radius:6px; }
    .um-oge { width:100%; display:flex; align-items:center; gap:10px; padding:8px 10px; margin-bottom:3px;
      background:rgba(0,60,80,.5); border:1px solid rgba(0,200,220,.2); border-radius:6px; color:#e6f6ff; cursor:pointer; transition:.12s; font-size:12px; }
    .um-oge:hover { background:rgba(0,120,150,.5); border-color:rgba(0,220,240,.5); transform:translateX(2px); }
    .um-oge.vurgu { background:linear-gradient(90deg,rgba(10,132,192,.4),rgba(11,179,158,.4)); border-color:rgba(0,220,240,.5); font-weight:600; }
    .um-s { font-size:16px; width:22px; text-align:center; }
    .um-ad { flex:1; text-align:left; }
    .um-ok { color:#5fd9f5; font-size:16px; }
  `]
})
export class FikoUretimMenuComponent {
  @Input() pencere: any;
  @Input() ayarlar: any = {};
  @Input() ana: any = null;   // parent FikoYT3DComponent

  ogeler: MenuOge[] = [
    { ad: 'Üretim Kartı (Dashboard)', simge: '📋', metod: 'acUretimKartiDialog', vurgu: true, grup: 'ANALIZ', alt: 'uretim_karti' },
    { ad: 'Kayıtlı Belgeler 📂', simge: '🗂️', metod: 'acKayitlarDialog' },
    { ad: 'Anlık Teklif / Maliyet', simge: '🧮', metod: 'acTeklifDialog', grup: 'ANALIZ', alt: 'teklif' },
    { ad: 'Üretim Takvimi / Termin', simge: '📅', metod: 'acTakvimDialog', grup: 'ANALIZ', alt: 'uretim_takvimi' },
    { ad: 'Oto Özellik Tanıma → CAM', simge: '🔍', metod: 'acFeatureTaniDialog', grup: 'ANALIZ', alt: 'feature_tani' },
    { ad: 'Kesim Maliyeti (Lazer/Plazma)', simge: '✂️', metod: 'acKesimDialog', grup: 'CAM', alt: 'kesim_maliyeti' },
    { ad: 'Kesme Parametreleri (CNC)', simge: '⚙️', metod: 'acKesmeParametreDialog', grup: 'CAM', alt: 'kesme_parametre' },
    { ad: 'Büküm Açınımı (Sac Metal)', simge: '📐', metod: 'acBukumDialog', grup: 'ANALIZ', alt: 'bukum_acinim' },
    { ad: 'Yüzey İşlem / Kaplama', simge: '🎨', metod: 'acKaplamaDialog', grup: 'ANALIZ', alt: 'kaplama_maliyeti' },
    { ad: 'Malzeme / Maliyet / CO₂', simge: '🌿', metod: 'acMalzemeKarsilastirDialog', grup: 'ANALIZ', alt: 'malzeme_karsilastir' },
    { ad: 'Nesting / Yerleşim', simge: '▦', metod: 'acNestingDialog', grup: 'ANALIZ', alt: 'nesting' },
    { ad: 'Tolerans Yığını (Stack-up)', simge: '⇡', metod: 'acToleransDialog', grup: 'OLCUM', alt: 'tolerans_yigini' },
    { ad: 'Muayene Raporu (FAI)', simge: '✓', metod: 'acMuayeneDialog', grup: 'OLCUM', alt: 'muayene' },
    { ad: 'QR İş Emri & Etiket', simge: '▣', metod: 'acIsEmriDialog', grup: 'CIZIM', alt: 'is_emri' },
    { ad: 'DXF Dışa Aktarma', simge: '📄', metod: 'acDxfDialog', grup: 'CIZIM', alt: 'dxf_disa' },
    { ad: 'Cıvata / Diş + Tork', simge: '🔩', metod: 'acCivataDialog' },   // ücretsiz referans
    { ad: 'Birim Çevirici', simge: '🔁', metod: 'acBirimDialog' },   // ücretsiz yardımcı
  ];

  /** Modül lisanslı mı (kısıtlama açıksa kilitli görünür). Köprü yoksa açık. */
  kilitli(o: MenuOge): boolean {
    if (!o.grup) return false;   // ücretsiz
    try { return this.ana?.lisans ? !this.ana.lisans(o.grup, o.alt) : false; } catch { return false; }
  }

  ac(o: MenuOge): void {
    if (this.kilitli(o)) return;   // kilitliyse açma (fiko-kilit zaten tıklamayı engeller)
    try { this.ana?.[o.metod]?.(); } catch { }
    try { this.pencere?.instance?.kapa?.(); } catch { }
  }
}
